import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";

    /**
	 * 
     * @property {integer} headerHeight                Website header height (in pixels)
     * @property {integer} visualCount                 Number of visuals
     * @property {integer} visualIndex                 Current visual index
     * @property {object}  $visualView 
     * @property {object}  $visualImages     
     */
    export default Backbone.View.extend({

        /**
         * Constructor
         *
         * @todo Refactor (copy of ProductStickyView.js scrollToAnchor() method)
         *       this.headerHeight property is part of it
         */
        initialize: function () {
            this.headerHeight = $(".js-Header").eq(0).height();
            this.visualCount = this.$(".js-PubliVisuals-item").length;
            this.visualIndex = 0;
            this.$visualView = this.$(".js-PubliVisuals-view");
            this.$visualImages = this.$(".js-PubliVisuals-image");
            this.$visualVideo = null;
            var $visualsItems = this.$(".js-PubliVisuals-item");

            var counter = 0;
            _.each($visualsItems, function ($visual, n) {
                var $iframe, $iframeContainer;
                if ($visual.getAttribute("data-type") === "video") {
                    if (counter === 0) {
                        $iframeContainer = $("<div class='PubliVisuals-videoContainer' style='position: absolute;left: -99999999999px;' />");
                        $iframe = $("<iframe src='' class='PubliVisuals-video' frameborder='0' allowfullscreen />");
                        $iframeContainer.append($iframe);
                        this.$visualView.append($iframeContainer);
                        this.$visualVideo = $iframeContainer;
                        counter += 1;
                    }
                    if (counter > 0) {
                        return;
                    }
                }
            }, this);
            this.render();
        },

        events: {
            "mouseover  .js-PubliVisuals-item":     "switchPreview",
            "click     .js-PubliVisuals-previous":  "previous",
            "click     .js-PubliVisuals-next":      "next"
        },

        /**
         * [switchPreview description]
         * 
         * @param {object} event
         */
        switchPreview: function (event) {
            var $target = $(event.target);
            var $thumbnail = $target.is(".js-PubliVisuals-item") ? $target : $target.parents(".js-PubliVisuals-item");

            this.visualIndex = $thumbnail.index();
            this.loadPreview();
        },

        loadPreview: function () {
            var $thumbnail = $(".js-PubliVisuals-thumbnails .js-PubliVisuals-item").eq(this.visualIndex),
                $iframe = _.isNull(this.$visualVideo) ? false : this.$visualVideo.children("iframe"),
                src = $thumbnail.data("src");
            if ($thumbnail.data("type") === "video") {
                this.$visualImages.hide();
                $iframe.attr("src", src);
                this.$visualVideo.removeAttr("style");
            } else {
                if (!$iframe) {
                    this.$visualImages.attr("src", src);
                } else {
                    $iframe.removeAttr("src");
                    this.$visualVideo.css({ "position": "absolute", "left": "-99999999999999999px" });
                    this.$visualImages.attr("src", src).show();
                }
            }
            
            this.$(".PubliVisuals-item--active").removeClass("PubliVisuals-item--active");
            $thumbnail.addClass("PubliVisuals-item--active");
        },

        previous: function () {
            this.visualIndex = ((this.visualIndex === 0) ? this.visualCount : this.visualIndex) - 1;
            this.loadPreview();
        },

        next: function () {
            this.visualIndex = (this.visualIndex === (this.visualCount - 1)) ? 0 : this.visualIndex + 1;
            this.loadPreview();
        },

        render: function () {
            this.$(".js-PubliVisuals-item").first().addClass("PubliVisuals-item--active");
            this.loadPreview();
        }

    });
